module.exports = __webpack_public_path__ + "static/bg (1)-6b5bce5cbd682772a5ab98ef08cf8f7f.jpg";